/**
 * Pixel size of an HTML mesh's DOM element, exactly as HtmlMeshManager creates it: a missing
 * dimension (or one below 4 px) falls back to 512, and both are rounded. The mesh's world
 * width is `scale.x * width / height` and its world height `scale.y`, so anything converting
 * between the live entity's scale and the scene's `scale` needs the same numbers (the editor's
 * gizmo write-back does).
 */
export function htmlMeshPixelSize(width?: number, height?: number): { width: number; height: number } {
    let pw = width || 512;
    let ph = height || 512;
    if (pw < 4) pw = 512;
    if (ph < 4) ph = 512;
    return { width: Math.round(pw), height: Math.round(ph) };
}
